<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="tprm-premium-sidebar print:hidden"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation"
  [opened]="!isScreenSmall"
>
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <div class="tprm-sidebar-workspace-card">
      <button
        type="button"
        class="tprm-sidebar-workspace-main"
        aria-label="Go to dashboard"
        (click)="goToDashboard()"
      >
        <span class="tprm-sidebar-client-logo" aria-label="Client workspace logo">
          @if (companyLogo) {
            <img [src]="companyLogo" alt="Client logo" />
          }
          @if (!companyLogo) {
            <span>TP</span>
          }
        </span>

        <span class="tprm-sidebar-workspace-copy">
          <span class="tprm-sidebar-kicker">One Vision</span>
          <span class="tprm-sidebar-title">Risk Command</span>
          <span class="tprm-sidebar-profile-line">
            {{ user?.name || "TPRM Admin" }}<span class="tprm-sidebar-profile-separator"> · </span>{{ user?.email || "admin@tprm.local" }}
          </span>
        </span>

        <mat-icon
          class="tprm-sidebar-workspace-arrow"
          [svgIcon]="'heroicons_outline:chevron-right'"
        ></mat-icon>
      </button>

      <a class="tprm-sidebar-workspace-link" [routerLink]="'/vendor-inventory'">
        <mat-icon [svgIcon]="'heroicons_outline:building-office-2'"></mat-icon>
        <span>Third Party Portfolio</span>
      </a>
    </div>
  </ng-container>

  <!-- Navigation footer hook -->
  <ng-container fuseVerticalNavigationFooter>
    <div class="tprm-sidebar-footer">
      <div class="tprm-sidebar-footer-title">Need help?</div>
      <a href="mailto:support@empliance.in" class="tprm-sidebar-footer-link">
        <mat-icon [svgIcon]="'heroicons_outline:envelope'"></mat-icon>
        <span>support&#64;empliance.in</span>
      </a>
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div
    class="bg-card fixed z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden"
  >
    <!-- Navigation toggle button -->
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
    </button>
    <!-- Components -->
    <div
      class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2"
      [ngClass]="{
        'mr-[304px]': !isScreenSmall && navigationOpened,
        'mr-0': isScreenSmall || !navigationOpened,
      }"
    >
      <search [appearance]="'bar'"></search>

      <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
      <button mat-icon-button [matMenuTriggerFor]="userActions">
        <span class="relative">
          @if (showAvatar && user?.avatar) {
            <img class="h-7 w-7 rounded-full" [src]="user?.avatar" />
          }
          @if (!showAvatar || !user?.avatar) {
            <mat-icon
              class="mt-1"
              [svgIcon]="'heroicons_outline:user-circle'"
            ></mat-icon>
          }
          <span
            class="absolute bottom-0 right-0 h-2 w-2 rounded-full"
            [ngClass]="{
              'mb-px mr-px': !showAvatar || !user?.avatar,
              'bg-green-500': user?.status === 'online',
              'bg-amber-500': user?.status === 'away',
              'bg-red-500': user?.status === 'busy',
              'bg-gray-400': user?.status === 'not-visible',
            }"
          ></span>
        </span>
      </button>
      <mat-menu [xPosition]="'before'" #userActions="matMenu">
        <button mat-menu-item>
          <span class="flex flex-col leading-none">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{ user?.email }}</span>
          </span>
        </button>
        <mat-divider class="my-2"></mat-divider>

        <button mat-menu-item (click)="signOut()">
          <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
          ></mat-icon>
          <span>Sign out</span>
        </button>
      </mat-menu>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-auto flex-col mt-14">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>
</div>

<!-- Quick chat -->
<quick-chat #quickChat="quickChat"></quick-chat>
